import { useAuth } from '../contexts/AuthContext';
import type { FeatureKey } from '../types/feature-keys.generated';

export function useFeatureEnabled(key: FeatureKey): boolean {
  const { isFeatureEnabled } = useAuth();
  return isFeatureEnabled(key);
}
